
import * as React from 'react'
import { Form } from 'react-bootstrap'
import { Typography, Box, Grid, TextField, Theme } from '@mui/material'
import NumberFormatCustom from '../../../../../components/NumberFormatCustom'
import _ from 'lodash'
import { copyObject } from '../../../../../utils'
import { createStyles, makeStyles } from '@mui/styles'
import { PackingMaterialsLineItemT, PackingMaterialsValueObj } from '../../../../../types/PackingMaterialsT'
import { useImmer } from 'use-immer'
import NumberFormatValidate from '../../../../../components/NumberFormatValidate'
import { useMemoCompare } from '../../../../../utils/hooks'
 const useStyles = makeStyles((theme: Theme) => createStyles({
    textFieldAmount: {
        "& .MuiInput-root": {
            "&::before": {
                borderBottomStyle: "solid",
            }
        },
    },

}));

export type ILineItemPackingMaterialsProps = {
    index: number
    item: PackingMaterialsLineItemT
    onChangeValue(index: number, key: string, value: any, isDirty: boolean): void
}
const LineItemPackingMaterials: React.FunctionComponent<ILineItemPackingMaterialsProps> = (props): JSX.Element => {
    // const classes = useStyles()
    const [isReady, setIsReady] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState<PackingMaterialsLineItemT>({
        item: null,
        label: null,
        quantity: null,
        rate: null,
        amount: null,
        isDirty: null
    });


    const currentItemFinal = useMemoCompare(props.item, (prev, next) => {
        return prev && (prev.quantity === next.quantity && prev.rate === next.rate);
    });

    React.useEffect(() => {
        // console.log("currentItemFinal", currentItemFinal)
        if (!_.isEqual(currentItemFinal, currentItem)) {
            // console.log("LineItemPackingMaterials", props.item)
            setCurrentItem(Object.assign({}, props.item))
            setIsReady(true)
        }
    }, [currentItemFinal]);



    const handleChange = (key: string, value: any, isDirty: boolean = false) => {
        props.onChangeValue(props.index, key, value, isDirty)
        setCurrentItem((draft) => {
            draft[`${key}`] = value
            return draft
        })
    };

    const renderBootstrapFields = () => {
        return (
            <>
                <Form.Group>


                    <Form.Label>Quantity, $</Form.Label>
                    <NumberFormatValidate
                        // @ts-ignore
                        customInput={Form.Control}
                        className="input-material"
                        type="text"
                        defaultValue={`${currentItem.quantity}`}
                        value={`${currentItem.quantity}`}
                        onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            if (floatValue != currentItem.quantity) {
                                handleChange("quantity", value)
                            }
                        }}
                        mask="_"
                        fixedDecimalScale={true}
                        decimalScale={2}
                    />
                </Form.Group>
                <Form.Group>


                    <Form.Label>Rate, $</Form.Label>
                    <NumberFormatValidate
                        // @ts-ignore
                        customInput={Form.Control}
                        className="input-material"
                        type="text"
                        defaultValue={`${currentItem.rate}`}
                        value={`${currentItem.rate}`}
                        onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            if (floatValue != currentItem.rate) {
                                handleChange("rate", value, true)
                            }
                        }}
                        mask="_"
                        prefix='$'
                        fixedDecimalScale={true}
                        decimalScale={2}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Total, $</Form.Label>
                    <NumberFormatValidate
                        disabled={true}
                        customInput={Form.Control}
                        className="input-material"
                        type="text"
                        defaultValue={Number(currentItem.quantity) * Number(currentItem.rate)}
                        value={Number(currentItem.quantity) * Number(currentItem.rate)}
                        onValueChange={(values) => {

                        }}
                        mask="_"
                        fixedDecimalScale={true}
                        decimalScale={2}
                    />
                </Form.Group>
            </>
        )
    }

    const renderMaterialFields = () => {
        return (
            <>
                <TextField
                    variant="standard"
                    fullWidth
                    value={currentItem.quantity}
                    label="Quantity"
                    InputProps={{
                        inputComponent: NumberFormatCustom as any,
                        inputProps: {
                            // fixedDecimalScale: true,
                            decimalScale: 2,
                            mask: "_",
                        }

                    }}
                    onChange={(event: any) => {
                        let value = event.target.value
                        if (value != currentItem.quantity) {
                            handleChange("quantity", value)
                        }

                    }}
                />


                <TextField
                    variant="standard"
                    fullWidth
                    value={`${currentItem.rate}`}
                    label="Rate"
                    id={`numberformat-${props.index}`}
                    name={`numberformat-${props.index}`}
                    InputProps={{
                        inputComponent: NumberFormatCustom as any,
                        inputProps: {
                            fixedDecimalScale: true,
                            decimalScale: 2,
                            mask: "_",
                            thousandSeparator: true,
                            prefix: '$',

                        }

                    }}
                    onChange={(event: any) => {
                        let value = event.target.value
                        if (value != currentItem.rate) {
                            handleChange("rate", value, true)
                        }
                    }}
                />

                <TextField
                    variant="standard"
                    fullWidth
                    disabled
                    style={{
                        // borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
                    }}
                    value={Number(currentItem.quantity) * Number(currentItem.rate)}
                    label="Amount"
                    // className={classes.textFieldAmount}

                    InputProps={{
                        inputComponent: NumberFormatCustom as any,
                        inputProps: {
                            fixedDecimalScale: true,
                            decimalScale: 2,
                            mask: "_",
                            thousandSeparator: true,
                            prefix: '$'
                        }

                    }}
                />

            </>
        )
    }

    const renderContent = () => {
        // console.log("LineItemPackingMaterials->currentItem", currentItem)

        return (
            <Grid
                item
                xs={12}
                key={props.index}
            >

                <Box style={{ display: 'grid', gridTemplateColumns: 'minmax(200px, 1fr) 2fr 2fr 2fr' }}>
                    <Box display="flex" alignItems="flex-end">
                        <Typography>{currentItem.label}</Typography>
                    </Box>
                    {renderBootstrapFields()}

                </Box>
            </Grid>
        )
    }


    return (
        <>
            {renderContent()}
        </>
    )
}

export default LineItemPackingMaterials
